var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58877 5.24023C3.58877 4.88125 3.87978 4.59023 4.23877 4.59023H14.3913C14.6376 4.59023 14.8808 4.64538 15.103 4.75162L17.6635 5.97577V9.12912L15.103 10.3533C14.8808 10.4595 14.6376 10.5147 14.3913 10.5147H4.23877C3.87978 10.5147 3.58877 10.2236 3.58877 9.86466V5.24023Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0083 6.15234H9.00083",
    stroke: "#00C65E",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0083 7.83008H9.00083",
    stroke: "#00C65E",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5673 9.03697V6.02987L20.4027 6.03031C20.6139 6.03042 20.8119 6.13313 20.9336 6.30572L21.5357 7.15954C21.6941 7.38416 21.6941 7.68412 21.5357 7.90873L20.934 8.76201C20.8121 8.93479 20.6139 9.03752 20.4024 9.03741L19.5673 9.03697Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2385 7.80312C23.4318 7.80312 23.5885 7.64642 23.5885 7.45312C23.5885 7.25983 23.4318 7.10313 23.2385 7.10313V7.80312ZM21.7979 7.80312H23.2385V7.10313H21.7979V7.80312Z",
    fill: "#363A45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06115 16.2L6.73525 10.5395H10.5924L9.91827 16.2H6.06115Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.71621,
    y: 16.3832,
    width: 6.47101,
    height: 3.78183,
    rx: 0.65,
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0137,
    y: 5.67969,
    width: 2.00059,
    height: 3.708,
    fill: "#00C65E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.1b3f7176e915fd7a406fd0505bd44be1.svg";
export { ForwardRef as ReactComponent };